export default __webpack_public_path__ + "static/media/l1.e3b90057.jpg";